// useDownlineLabel — the name of the downline an agent CREATES/manages, derived
// from their own level: Super Master → "Master(s)", Master → "Agent(s)". Used across
// the sub-agent hub (title, tabs, QR caption, recharge copy) so every surface calls
// the downline by the right role instead of the generic "Agent / sub-agent".
// Level names are English (mirrors admin app + the top-bar / dashboard badges).

import { useAdminAuth } from './adminAuth';

const LEVEL_NAMES: Record<number, string> = { 1: 'Super Master', 2: 'Master', 3: 'Agent' };

export function useDownlineLabel() {
  const { admin } = useAdminAuth();
  const childLevel = Number(admin?.level ?? 1) + 1;
  const singular = LEVEL_NAMES[childLevel] || 'Agent';
  return {
    singular,                          // "Master"  | "Agent"
    plural: `${singular}s`,            // "Masters" | "Agents"
    lower: singular.toLowerCase(),     // "master"  | "agent"
    lowerPlural: `${singular.toLowerCase()}s`,
  };
}
